<template>
  <div id="sovdetail">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader || loader3 ">
      <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
    </div>
    
  	<div class="datepickerwrap">
  		<div class="leftcontent wrapitem">
  			<div class="datebox">
  	 			<datepicker placeholder="From" @input="changeCustomDate" v-model="date.startDate" />
  	 		</div>
  	 		<div class="datebox">
          <select v-model="selected_website" class="form-control text-uppercase">
          	<option value="https://www.amazon.com">Amazon</option>
          </select>
        </div>
        <div class="datebox" style="width:18%">
          <select  class="form-control text-uppercase">
            <option>Bluetooth Headphone</option>
          </select>
        </div>
  	 		<div class="datebox">
          <button @click="refresh" class="btn btn-block weavrpurple" type="button">
            <span style="font-size:13px">Submit</span>
          </button>
        </div>
  	 	</div>
  	</div>
    <div class="container-fluid ">
      <div class="row ">
          <div class="col-md-6 mycols"  v-if="showBrand">
            <div class="card" >
              <div style="margin:0" class="space-between-header">
                <p style="margin:0;padding-bottom:0!important" class="p-2">SOV Bluetooth Headphone Search</p>
              </div>
              <highcharts :options="charts_sos" v-if="activeChart" ></highcharts>
            </div>
          </div>
         
          <div class="col-sm-6 mycols">
            <div class="card" >
              <div style="margin:0" class="space-between-header">
                <p style="margin:0;padding-bottom:0!important" class="p-2">SOV Position on Page</p>
              </div>
              <highcharts   :options="categorySearchGraph" v-if="activecategorySearchGraph" ></highcharts>
            </div>
          </div>
      </div>    
      <!-- <div class="card p-2" style="margin-bottom:4px" >
        <table id="myTable" class="table table-bordered">
          <thead class="thead-normal">
            <tr>
              <th v-for="d in columns" :key="d.field"> {{ d.label  }} </th>
            </tr>
          </thead>
          <tbody class="tbody-normal" > 
            <tr v-for="(r,i) in rows" :key="i">
              <td v-for="d in columns" :key="d.field"> 
                {{r[d.field]}}<span v-if="d.field == 'page_1_sov' || d.field == 'page_all_sov'">%</span>
              </td>
            </tr>
          </tbody>
        </table>  
       </div>   -->
     
        <div  class="space-between-header">
          <h4 >SOV trend for bluetooth headphone search pages (1-3)</h4>
          <div> 
            <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
              <b-form-radio-group class="  radiohide" id="radiosBtn" buttons button-variant="outline-secondary" v-model="sovInterval" name="radiosBtn">
                <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                <b-form-radio onclick="return false" class="mx-0 disabled" value="week">Week</b-form-radio>
                <b-form-radio onclick="return false" class="mx-0 disabled" value="month">Month</b-form-radio>
              </b-form-radio-group>
              <button style="margin-left: 6px;height: 30px;border: none;background: #8a87e8;color: white;">From</button>
              <datepicker  placeholder="From" @input="getDailyData" v-model="sovStartDate" />
              <button style="margin-left: 6px;height: 30px;border: none;background: #8a87e8;color: white;">To</button>
              <datepicker class="picker-left"   placeholder="To" @input="getDailyData" v-model="sovEndDate" />
            </b-button-toolbar>
          </div>
        </div>
        <div class="card p-2">
        <highcharts style="width:100%;" :options="daywiseChart" ></highcharts>
        </div>
      
     
<!--       
        <div class="space-between-header"> 
          <h4 >Compliance Score </h4>
          <h5 style="line-height: 36px;margin-bottom:0;">
            {{ websitesUrls3[selected_website] }}: 
            <span style="color:rgb(53 104 250);">{{ selectedWebComplianceScore }}</span>
          </h5>
         
          <div @click="goToCompliance" class="sovdetails listing-custom badge badge-primary">Show Details</div>
       
        </div> 
        <div class="card p-2">
          <highcharts :options="comChart" v-if="activeComChart" ></highcharts> 
        </div>    -->
        <div class="space-between-header"> 
          <h3 ></h3>
          <div style="display:inherit" > 
            <div @click="showProductModal"  style="display:flex;cursor:pointer" >
              <div style="padding: 5px;height: 30px;border: none;background: #8a87e8;color: white;">Products</div>
              <div style="background: white;padding-left: 14px;padding-right: 14px;font-size: 12px;padding-top: 8px; white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width: 214px;">
                {{ selectedProduct }}
              </div>
              <!-- <select @change="refreshReview" v-model="selectedProduct" class="form-control text-uppercase">  
                <option value="all">All</option>           
                <option v-for="(d,i) in productOptions" :key="i" :value="d">{{d}}</option>
              </select> -->
            </div>
            <div style="margin-left: 6px;padding: 5px;height: 30px;border: none;background: #8a87e8;color: white;">From</div>
  	 		  	<datepicker  placeholder="From" @input="refreshReview" v-model="reviewStartDate" />
  	 		  	<div style="margin-left: 6px;padding: 5px;height: 30px;border: none;background: #8a87e8;color: white;">To</div>
            <datepicker v-model="reviewEndDate" class="picker-left"   placeholder="To" @input="refreshReview" />
  	 	      <div @click="goToSenti" class="sovdetails listing-custom badge badge-primary">Show Sentiments</div> 
            </div> 
        </div> 
        <div class="card p-2" style="margin-bottom:4px">
          <div class="space-between-header">
            <h4>Total Reviews: {{ totalReviewCount | format }}</h4>
            <div> 
              <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                <b-form-radio-group class="  radiohide" id="radiosBtn" buttons button-variant="outline-secondary" v-model="revInterval" name="radiosBtn">
                  <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                  <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                  <b-form-radio class="mx-0" value="month">Month</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
            </div>
          </div>  
          <highcharts :options="reviewGraph" v-if="activeReviewGraph" ></highcharts>
          <div style="margin:15px"></div>
          <highcharts :options="creviewGraph" v-if="activeReviewGraph" ></highcharts>
        </div>  
        <div class="card p-2">
          <div class="space-between-header">
            <h4 > Avg. Rating: {{ ratingAvg }}</h4>
             <div style="display:flex"> 
              <b-button-toolbar  aria-label="Toolbar with buttons group">
                <b-form-radio-group class="  radiohide" id="radiosBtn" buttons button-variant="outline-secondary" v-model="revInterval" name="radiosBtn">
                  <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                  <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                  <b-form-radio class="mx-0" value="month">Month</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
              
            </div>
            
          </div>  
          <highcharts :options="ratingGraph" v-if="activeRatingGraph" ></highcharts>
          <div style="margin:15px"></div>
          <highcharts :options="cratingGraph" v-if="activeReviewGraph" ></highcharts>
          <p style="text-align: center;font-size: 12px;text-transform: initial;">Cumulative Rating = Cumulative Sum of Ratings / Cumulative Sum of Reviews</p>
        </div>   

        <div class="space-between-header"> 
          <h3 >Bluetooth Headphone Search Data </h3>
            <div> 
              <span style="line-height: 31px;margin-right: 10px;}">Pages:</span>
              <select @change="readyPie" v-model="selectedPage" class="form-control text-uppercase">
                <option value="1-3">1-3</option>
              </select>
            </div>  
        </div> 
      <div class="">
        <h4 style="display:inline-block">Bluetooth Headphone Listing</h4>
        <div @click="goToDetailPage" class="sovdetails listing-custom badge badge-primary">Show Details</div>
        
        
        <div class="row">
          <div class="col-sm-12 mycol" v-for="(d,i) in labelMapper" :key="i" >
            <div class="card" v-if="i=='brand'">
              <highcharts style="width:100%" v-if="activePie" :options="pieChartAMD[i]" ></highcharts>
              <span style="font-size: 13px;text-align: center;margin-top: -13px;z-index: 9999;padding-bottom: 10px;" >
              <span >Total Results: 48 </span>  
              </span>
            </div>
          </div>  
        </div>          
      </div>  
    </div>  
   <b-modal size="lg" title="Select Product" v-model="isProductModal" >
      <div style="position:relative">
        <input style="padding-left: 30px;" class="form-control" v-model="schProduct" type="text" placeholder="Search Product"/>
        <i style="position:absolute;left:0;top:0;padding: 10px;" class="fa fa-search"></i>
      </div>  
      <div style="padding-top:20px;cursor:pointer">
        <div  class="eachProduct" @click="selectProductNow('all')" style="padding: 4px;border-bottom: 1px solid #e6e6e6;" >All
          <span style="float:right" v-if="selectedProduct=='all'">
            <i class="fa fa-check"></i>
          </span>
        </div>
        <div v-if="d.indexOf(schProduct)!=-1" class="eachProduct" @click="selectProductNow(d)" style="padding: 4px;border-bottom: 1px solid #e6e6e6;" v-for="d in productOptions" > {{ d }}
          <span style="float:right" v-if="d==selectedProduct">
            <i class="fa fa-check"></i>
          </span>
        </div>
         
      </div>
    </b-modal>
  </div>
</template>
<script>  

import moment from 'moment'
import Datepicker from 'vuejs-datepicker'


export default {
  name: 'sovdetail',
  components: { Datepicker},
  data: function () {
    return {
    	selected_website: 'https://www.amazon.com',
      date:{
        startDate: moment().subtract(1,'days').format('YYYY-MM-DD')
      },
      websitesUrls: {
        "https://www.amazon.com": "amazon",
        "https://www.harveynorman.com.au": "harvey",
        "https://www.bestbuy.com": "BESTBUY",
        "https://www.currys.co.uk": "currys uk",
        "https://www.costco.com": "costco",
        "https://www.walmart.com": "walmart",
        "https://store.hp.com/us": "hp",
        "https://global.jd.com": "jd"
      },
      websitesUrls2: {
        "https://www.amazon.com": "amazon",
        "https://www.harveynorman.com.au": "harvey norman",
        "https://www.bestbuy.com": "BESTBUY",
        "https://www.currys.co.uk": "currys uk",
        "https://www.costco.com": "costco",
        "https://www.walmart.com": "walmart",
        "https://store.hp.com/us": "HP",
        "https://global.jd.com": "JD"
      },
      websitesUrls3: {
        "all": "All",
        "https://www.amazon.com": "amazon",
        "https://www.harveynorman.com.au": "harvey norman",
        "https://www.bestbuy.com": "bestbuy",
        "https://www.currys.co.uk": "Curry's",
        "https://www.costco.com": "costco",
        "https://www.walmart.com": "walmart",
        "https://store.hp.com/us": "HP",
        "https://global.jd.com": "JD"
      },
      oem_websites:['https://store.hp.com/us'],
      columns:[
        {label: 'Brand', field: 'brand', sortable: false},
        {label: 'Sub Brand', field: 'sub_brand', sortable: false},
        {label: 'Form Factor', field: 'form_factor', sortable: false},
        {label: 'Page 1 System Count', field: 'page_1_system_count'},
        {label: 'Page Count (page 1)', field: 'page_1_count'},
        {label: 'Page 1 SOV', field: 'page_1_sov'},

        {label: 'Pages 1-3 System Count', field: 'page_1_3_system_count'},
        {label: 'Pages Count (1-3)', field: 'page_1_3_count'},
        {label: 'Pages 1-3 SOV', field: 'page_1_3_sov'},

        {label: 'All Pages System Count', field: 'page_all_system_count',},
        {label: 'All Pages Count', field: 'page_all_count'},
        {label: 'All Pages SOV', field: 'page_all_sov'},
      ],
      rows:[],
      sos_rows:[],
      rows_details:[],
      page:1,
      charts: {},
      charts_sos:{},
      activeChart: false,
      labelMapper: {
        'brand': 'Brand',
        'processor_type': 'Processor',
        // 'gpu_type': 'GPU'
      },
      isProductModal : false,
    
      countAMD: {},
      pieChartAMD: {},
      barGraph: {},
      activePie: false,
      activeBarChart: false,
      selectedPage: '1-3',
      loader: true,
      pageDistributionData: {},
      sovSOSGraph: {},
      activesovSOSGraph: true,
      categorySearchGraph: {},
      activecategorySearchGraph: true,
      colorShades: {
        red: [
          "#f56464","#fb7878","#fb9178","#fbc778","#f57264","#f56485","#f56492",
        ],
        blue: [
          "#7887fb", "#788dfb","#78a6fb", "#78b2fb","#78d0fb","#78d6fb","#78c4fb"
        ],
        green: [
          "#9af575","#87d866","#80f564","#9bf564","#64f591","#64f570","#71b755",
        ]
      },
      index:{
        red: 0,
        blue: 0,
        green: 0 
      },
      daywiseChart: {},
      dailyData: [],
      amdCPUFilter: 'all' ,
      pieTotal: '',
      comChart: {},
      activeComChart: false,
      selectedProduct: '',
      productOptions: [],
      reviewStartDate: moment().subtract(1,'week').format('YYYY-MM-DD'),
      reviewEndDate: moment().format('YYYY-MM-DD'),
      reviewGraph: {},
      creviewGraph: {},
      activeReviewGraph: false,
      ratingGraph: {},
      cratingGraph:{},
      activeRatingGraph: false,
      totalReviewCount: '',
      ratingAvg: '',
      reviewStarData: {},
      sentimentData: {},
      sentimentChart: {},
      showBrand:true,
      activeSentimentChart: false,
      sovInterval: 'day',
      sovStartDate: moment().subtract(4,'days').format('YYYY-MM-DD'),
      sovEndDate: moment().format('YYYY-MM-DD'),
      revInterval: 'month',
      selectedWebComplianceScore: '',
      brand_list:[],
      gpu_list:[],
      schProduct: ''
    }
  },
  watch:
  {
    'sovInterval':function(){
      this.getDailyData()
    },
    'revInterval':function(){
      if(this.selectedProduct)
        this.getReviews()
    }
  },
  mounted()
  {
    this.reviewStartDate = moment().subtract(1,'year').startOf('year').format('YYYY-MM-DD')
    this.reviewEndDate = this.date.startDate
    this.sovStartDate = moment(this.date.startDate).subtract(4,'days').format('YYYY-MM-DD')
    this.sovEndDate = this.date.startDate

    if(this.selected_website=="https://store.hp.com/us")
    {
      this.showBrand = false
      this.labelMapper = {
        'processor_type': 'Processor',
      }
    }
    else
    {
      this.showBrand = true
      this.labelMapper = {
        'brand': 'Brand',
        'processor_type': 'Processor',
        // 'gpu_type': 'GPU'
      }
    }

    this.sov()
    this.website_details()
    this.ryzenVsNonRyzen()
    this.getDailyData()
    this.getComData()
    this.getProducts()
    if(this.selected_website != 'all')
      localStorage.selected_website = this.selected_website
  },
  methods: {
    selectProductNow(d){
      let self = this
      self.selectedProduct = d
      self.refreshReview()
      self.isProductModal = false
    },
    showProductModal(){
      let self = this
      self.isProductModal = true
    },
    goToCompliance(){
      let self = this
      localStorage.selectedWebComplianceScore = self.selectedWebComplianceScore
      window.location =  "#/compliance-detail"
    },
    formatDate(key,d){
      let self = this
      let obj = {
        'day': moment(d).format('MMM DD, YY'),
        'month': moment(d).format('MMM YY'),
        'week': ''
      }
      if (self[key]=='week')
      {
        let end_date = moment(d).add(6,'days')
        let today = moment(self.date.startDate)
        if(end_date >= today)
          end_date = today
        obj['week'] = moment(d).format('MMM DD, YY') + " - " +  moment(end_date).format('MMM DD, YY')
      }
      return obj[this[key]]
    },
    drawReviewGraph(reviewData){
      let self = this
      self.totalReviewCount = reviewData.count
      let revRat = [
        { label:'Review', key:'review_count', graph:'reviewGraph', active:'activeReviewGraph' },
        { label:'Rating', key:'rating', graph: 'ratingGraph', active: 'activeRatingGraph' },
        { label:'Cummulative Review', key:'commulative_review_count', graph:'creviewGraph', active:'activeReviewGraph' },
        { label:'Cummulative Rating', key:'commulative_rating', graph:'cratingGraph', active:'activeReviewGraph' },
        // { label:'Rating', key:'rating', graph: 'ratingGraph', active: 'activeRatingGraph' }
      ]
      let sumRating = 0
      for(let [idx, dataset] of reviewData.timeline.entries()) 
      {
        sumRating += dataset.rating
      }
      self.ratingAvg = sumRating/reviewData.timeline.length
      self.ratingAvg = Math.round(self.ratingAvg)
      let y_labels = ['Review Count','Avg. Rating','Cummulative Review Count','Cummulative Rating']
      let tick_arr = [50,1]
      let max_arr = [undefined,5]
      for (let [ii, rr] of revRat.entries())
      {
        let cat = []
        let data = []
        for(let [idx, dataset] of reviewData.timeline.entries()) 
        {
          cat.push(self.formatDate('revInterval',dataset.date))
          data.push(dataset[rr.key])
        }
        self[rr.graph] = {
          chart: {
              type: 'line',
              height:180
          },
          title: {
              text: ''
          },
          subtitle: {
              text: ''
          },
          xAxis: {
              categories: cat,
              title: {
                  text: null
              }
          },
          plotOptions: {
              line: {
                  // dataLabels: {
                  //     enabled: true,
                  //     style:{fontWeight:0},
                  //     formatter:function(){
                        
                  //       let d = this.series.userOptions.detail[this.point.index]
                      
                  //       return this.point.y + '% (' + d + ')'
                  //     },
                  // }
              }
          },
          yAxis: {
              min: 0,
              tickInterval:tick_arr[ii],
              max:max_arr[ii],
              title: {
                  text: y_labels[ii],
        
              },
          },
          tooltip: {
            formatter: function() {
                  var mytooltip = this.key + '<br/>';
                  
                  mytooltip += '<span style="color:' + this.series.color + '">\u25CF</span> '
                    mytooltip += this.series.name
                    mytooltip += ' : <b> ' + self.format(this.y);

                    mytooltip += '</b><br/>'
                  
                  return mytooltip;
                },
          },
        
          legend: {
              enabled:false
          },
          credits: {
              enabled: false
          },
          series: [{
              name: rr.label,
              data: data,
              color: '#ffa500a8',
          }]
        }
        if(rr.graph=='ratingGraph')
          self['ratingGraph']['yAxis']['min'] = 1
        setTimeout(function(){
          self[rr.active] = true
        },200)
      }
    },
    getReviews(){
      let self = this
      self.loader = true
      self.activeReviewGraph = false
      let payload = {
        "start_date":moment(self.reviewStartDate).format('YYYY-MM-DD'),
        "end_date":moment(self.reviewEndDate).format('YYYY-MM-DD'),
        "interval": self.revInterval,
        "client": "plantronics",
        "item_category": "headphones"
        
  
      }
      if (self.selected_website != 'all')
      {
        payload["channel"] = self.websitesUrls[self.selected_website]
      }
      if ( self.selectedProduct != 'all')
      {
        payload["product_name"] = self.selectedProduct
      }
     
      const url = "/api/websites/review_histogram"
      self.$http.post(url, payload ).then(response => {
        self.loader = false
        self.drawReviewGraph(response.body.data)
      }, err => {
        self.loader = false
      });

    },
    refreshReview(){
      let self = this
      if(self.selectedProduct)
        self.getReviews()
    },
    getProducts(){
      let self = this
      self.loader = true
      self.productOptions = []
      self.selectedProduct = ''
      const url = "/api/websites/website_products"
      let payload = {}
      payload["website"] = []
      if (self.selected_website == 'all')
      {
        for(let [idx, dataset] of Object.entries(self.websitesUrls))
        {
          if(dataset !='hp') payload["website"].push(idx)
        }
      }
      else
      {
        payload["website"].push(self.selected_website)
      }
      self.$http.post(url, payload).then(response => {
        self.loader = false
        if (!response.body.data.length)
        {
          self.drawReviewGraph({count:0,timeline:[]})
          return
        }
        self.productOptions = ['plantronics voyager focus uc stereo', 'jabra evolve 75 uc', 'bose noise cancelling wireless headphone', 'sony wh-1000xm4']
        self.selectedProduct = self.productOptions[0]
        self.refreshReview()
      }, err => {
        self.loader = false
      });
    },
    drawComChart(d){
      let self = this
      let categories = []
      let data1 = []
      let arr = []
      let highlight_color = ''
      let sumFinalScore = 0
      for(let [idx, dataset] of Object.entries(d)) 
      {
        if(self.selected_website == idx )
        {
          self.selectedWebComplianceScore = dataset.final_complaince_score
        }
        else if (self.selected_website == 'all')
        {
          sumFinalScore += dataset.final_complaince_score
        }
        arr.push({url:idx,data:dataset.final_complaince_score,total:dataset.total_count})
      }
      if (self.selected_website == 'all')
      {
        self.selectedWebComplianceScore = Number(sumFinalScore/Object.keys(d).length).toFixed()
      }
      
      let sortedArr =  arr.sort((a, b) =>  a.data - b.data);
      let newsortedArr = []
      for(let [idx, dataset] of sortedArr.entries())
      {
        if(self.oem_websites.includes(self.selected_website))
        {
          if(self.oem_websites.includes(dataset.url))
            newsortedArr.push(dataset)
        }
        else
        {
          if(!self.oem_websites.includes(dataset.url))
            newsortedArr.push(dataset)
        }
      }
      for(let [idx, dataset] of newsortedArr.entries())
      {
        if(newsortedArr.length == 1)
          categories.push(self.websitesUrls3[dataset.url])
        else
        {
          if(idx==0)
            categories.push(self.websitesUrls3[dataset.url]+'<br/> <b>(Least Compliant)</b>')
          else if(idx == newsortedArr.length-1)
            categories.push(self.websitesUrls3[dataset.url]+'<br/> <b>(Most Compliant)</b>')
          else
            categories.push(self.websitesUrls3[dataset.url])
        }
        if(self.selected_website == dataset.url)
          highlight_color = '#6a2798'
        else
          highlight_color = '#8a87e8'
        data1.push({'y':dataset.data,color:highlight_color})
      }
      let plotLine = []
      if (data1.length==7) plotLine.push({ color: 'black',width: 1,value: data1[3].y,dashStyle: 'shortdash',zIndex: 4})
      else plotLine = []
      self.comChart = {
            chart: {
            type: 'column',
            height:230,
            marginTop: 45
        },
        title: {
            text: ' '
        },
        subtitle: {
            text: ''
        },
        xAxis: {
            categories: categories,
            title: {
                text: 'Websites'
            }
        },
        plotOptions: {
            column: {
              dataLabels: {
                  enabled: true,
                  style:{fontWeight:0},
                  formatter:function(){
                    return this.point.y   
                  },
              }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Compliance Score',
      
            },
            plotLines: plotLine,
        },
        tooltip: {
          shared:true,
          enabled: false
        },
      
        legend: {
            enabled:false
        },
        credits: {
            enabled: false
        },
        series: [{
            name: '',
            data: data1,
            // color: '#8a87e8',
            pointWidth: 60,
            dataSorting: {
                enabled: true
            },
            
        }]
      }
      setTimeout(function(){
        self.activeComChart = true
      },0)
    },
    getComData(){
      let self = this
      self.loader = true
      self.activeComChart = false
      const url = "/api/websites/compliance_score"
      self.$http.post(url, { "timestamp": self.date.startDate}).then(response => {
        self.loader = false
        self.drawComChart(response.body.data)
      }, err => {
        self.loader = false
      });
      
    },
    goToDetailPage(){
      window.location = "#/sov-detailed-plantronics"
    },
    goToSenti(){
      window.location = "#/sentiment"
    },
    drawDailyChart(){
      let self = this
      let categories = []
      let data3 = []
      let data4 = []
      let amdSov = []
      let detail1 = []
      let detail2 = []
      let detail3 = []
      let laptop_count = 0
      for(let [idx, dataset] of this.dailyData.entries()) 
      {  
        categories.push(self.formatDate('sovInterval',dataset.timestamp))
        laptop_count = 48
        let ryzensov = Number(dataset.ryzen_sov.toFixed())
        let nonryzensov = Number(dataset.non_ryzen_sov.toFixed())
        data3.push(ryzensov)
        data4.push(nonryzensov)
        amdSov.push(ryzensov + nonryzensov)
        detail1.push(dataset.ryzen + '/' + dataset.page_count)
        detail2.push(dataset.non_ryzen + '/' + dataset.page_count)
        detail3.push((dataset.ryzen + dataset.non_ryzen) + '/' + dataset.page_count)
      }
      self.daywiseChart = {
            chart: {
            type: 'line',
            height:230
        },
        title: {
            text: ''
        },
        subtitle: {
            verticalAlign:'bottom',
            text: 'Total Results: '+laptop_count
        },
        xAxis: {
            categories: [ "Jan 15, 21", "Jan 16, 21", "Jan 17, 21", "Jan 18, 21","Jan 19, 21"],
            title: {
                text: null
            }
        },
        plotOptions: {
            line: {
                dataLabels: {
                    enabled: true,
                    style:{fontWeight:0},
                    formatter:function(){
                      
                      let d = this.series.userOptions.detail[this.point.index]
                     
                      return this.point.y + '%'
                    },
                }
            }
        },
        yAxis: {
          
            title: {
                text: '',
      
            },
        },
        tooltip: {
          shared:true
        },
      
        legend: {
            enabled:true
        },
        credits: {
            enabled: false
        },
        series: [
        {
            name: 'Plantronics SOV',
            data: [0, 0, 0, 0, 0],
            color: '#fb7878',
            tooltip: {
                valueSuffix: ' %'
            },
            detail: detail3
        }]
      }
      // if(self.selected_website=="https://store.hp.com/us")
      //   self.daywiseChart.subtitle.text = ""
    },
    getDailyData(){
      let self = this
      self.loader4 = true
      const url = "/api/websites/daily_sov"
      let payload = {}
      payload["website"] = []
      payload["timestamp"]  = self.date.startDate
      payload["interval"] = self.sovInterval
      payload["start_date"] = moment(self.sovStartDate).format('YYYY-MM-DD')
      payload["end_date"] = moment(self.sovEndDate).format('YYYY-MM-DD')
      if (self.selected_website == 'all')
      {
        for(let [idx, dataset] of Object.entries(self.websitesUrls))
        {
          if(dataset !='hp') payload["website"].push(idx)
        }
      }
      else
      {
        payload["website"].push(self.selected_website)
      }
      self.$http.post(url, payload).then(response => {
        self.loader4 = false
        self.dailyData = response.body.data
        self.drawDailyChart()
      }, err => {
        self.loader4 = false
      });
    },
    
    processCategorySearchGraph(){
      let self = this
      let cat = self.pageDistributionData.category
      let srch = self.pageDistributionData.search
      let catTotal =  cat[1] + cat[2] + cat[3] 
      let srchTotal =  srch[1] + srch[2] + srch[3] 

      self.categorySearchGraph = {      
        chart: {
            type: 'column',
            height: 320
        },
        credits: {
          enabled: false
        },
        title: {
            text: ''
        },
        xAxis: {
            opposite: true,
            categories: ['bluetooth headphone search page']
        },
        yAxis: {
          min: 0,
          max: 100,
          title: {
              text: ''
          },
      },        
        tooltip: {
           enabled: false,
    
        },
        plotOptions: {
            column: {
               
                stacking: 'percent',
                dataLabels: {
                  enabled: true,
                  useHTML: true,
                  zIndex:0,
                  formatter: function() {
                    
                    return  '<span style="color:white;font-size:10px;font-weight:normal;background-color:#00000085;padding:4px">' +self.format(Number(this.point.percentage.toFixed())) + '% </span>'
                },
               }
            }
        },
        series: [{
            name: 'Page 1',
            data: [(0/25)*100],
            color:'#00800080',
            borderWidth: 0,
            minPointLength: 15,
        }, {
            name: 'Page 2',
            data: [(0/25)*100],
            color:'#ffa5008a',
            borderWidth: 0,
            minPointLength: 10,
        },{
            name: 'Page 3',
            data: [(0/25)*100],
            color:'#ff00008a',
            borderWidth: 0,
            minPointLength: 5,
        } ]
      }
      if(self.selected_website=="https://store.hp.com/us")
      {
        self.categorySearchGraph.xAxis.categories = ['laptop category page']
        self.categorySearchGraph.series = [{
            name: 'Page 1',
            data: [cat[1]],
            color:'#00800080',
            borderWidth: 0,
        }, {
            name: 'Page 2',
            data: [cat[2]],
            color:'#ffa5008a',
            borderWidth: 0,
        },{
            name: 'Page 3',
            data: [cat[3]],
            color:'#ff00008a',
            borderWidth: 0,
        } ]
      }
    },
    processSOVSOSGraph(){
      let self = this
      let sov = {
        ryzen: ((self.pageDistributionData.sov.ryzen)/self.pageDistributionData.sov.total)*100,
        nonRyzen: ((self.pageDistributionData.sov.non_ryzen)/self.pageDistributionData.sov.total)*100,
      }
      let sos = {
        ryzen: ((self.pageDistributionData.sos.ryzen)/self.pageDistributionData.sos.total)*100,
        nonRyzen: ((self.pageDistributionData.sos.non_ryzen)/self.pageDistributionData.sos.total)*100,
      }
      sov.ryzen = Number(sov.ryzen.toFixed())
      sov.nonRyzen = Number(sov.nonRyzen.toFixed())
      sos.ryzen = Number(sos.ryzen.toFixed())
      sos.nonRyzen = Number(sos.nonRyzen.toFixed())
      let maxScale = sos.ryzen+sos.nonRyzen + 5
      if (sov.ryzen+sov.nonRyzen > sos.ryzen+sos.nonRyzen)
      {
        maxScale = sov.ryzen+sov.nonRyzen + 5
      }
      self.sovSOSGraph = {      
        chart: {
            type: 'column',
            height:320,
        },
        credits: {
          enabled: false
        },
        title: {
            text: ''
        },
        xAxis: {
            opposite: true,
            categories: [
              'All Laptop Category Pages <br/> Total Laptops = ' + self.pageDistributionData.sov.total,
              'All Laptop Search Pages <br/> Total Laptops = ' + self.pageDistributionData.sos.total
            ]
        },
        yAxis: { 
          min: 0,
          max: maxScale,
          title: {
              text: ''
          },
          stackLabels: {
            enabled:true,
            formatter:function(){
              let suf = ''
              let total = ''
              if (this.x==0)
              {
                suf = (self.pageDistributionData.sov.ryzen + self.pageDistributionData.sov.non_ryzen )
                total = self.pageDistributionData.sov.total
              }  
              else  
              { 
                suf = (self.pageDistributionData.sos.ryzen + self.pageDistributionData.sos.non_ryzen )
                total = self.pageDistributionData.sos.total
              }  
              return 'AMD:' + this.total + '%' 
            }
          }
      
      },        
        tooltip: {
           enabled:false,
          
        },
        plotOptions: {
            column: {
                stacking: 'normal',
                dataLabels: {
                  enabled: true,
                  useHTML: true,
                  formatter: function() {
                    let mapper = {}
                    let d = this.series.userOptions.myData[this.point.index]
                    
                    mapper['Ryzen SOV'] = d.ryzen + '/' + d.total
                    mapper['Non-Ryzen SOV'] = d.non_ryzen + '/' + d.total
                    
                    return  '<span style="color:white;font-size:11px;font-weight:normal;background-color:#00000085;padding:2px">' +self.format(this.point.y) + '%'
                },
               }
            }
        },
        series: [{
            name: 'Ryzen SOV',
            data: [sov.ryzen,sos.ryzen],
            color:'#ffa500a8',
            borderWidth: 0,
            myData: [self.pageDistributionData.sov,self.pageDistributionData.sos]
        }, {
            name: 'Non-Ryzen SOV',
            data: [sov.nonRyzen,sos.nonRyzen],
            color:'grey',
            borderWidth: 0,
            myData: [self.pageDistributionData.sov,self.pageDistributionData.sos]
         }
        ]
      }
      if(self.selected_website=="https://store.hp.com/us")
      {
        self.sovSOSGraph.xAxis.categories = ['All Laptop Category / Search Pages <br/> Total Laptops = ' + self.pageDistributionData.sov.total]
        self.sovSOSGraph.series = [{
            name: 'Ryzen SOV',
            data: [sov.ryzen],
            color:'#ffa500a8',
            borderWidth: 0,
            myData: [self.pageDistributionData.sov]
        }, {
            name: 'Non-Ryzen SOV',
            data: [sov.nonRyzen],
            color:'grey',
            borderWidth: 0,
            myData: [self.pageDistributionData.sov]
         }
        ]
      }

    },
    ryzenVsNonRyzen(){
      let self = this
      self.loader3 = true
      self.activecategorySearchGraph = false
      const url = "api/websites/page_distribution"
      let payload = {}
      payload["website"] = []
      payload["timestamp"]  = self.date.startDate
      if (self.selected_website == 'all')
      {
        for(let [idx, dataset] of Object.entries(self.websitesUrls))
        {
          if(dataset !='hp') payload["website"].push(idx)
        }
      }
      else
      {
        payload["website"].push(self.selected_website)
      }
      self.$http.post(url,payload).then(response => {
        self.loader3 = false
        self.pageDistributionData = response.body.data
        self.processSOVSOSGraph()
        self.processCategorySearchGraph()
        self.activecategorySearchGraph = true
      }, err => {
        self.loader3 = false
      });
    },
    format(v)
    {
      return this.$options.filters.format(v)
    },
    refresh(){
      $('#myTable').DataTable().destroy();
      if(this.selected_website != 'all')
        localStorage.selected_website = this.selected_website
      if(this.selected_website=="https://store.hp.com/us")
      {
        this.showBrand = false
        this.labelMapper = {
          'processor_type': 'Processor',
        }
      }
      else
      {
        this.showBrand = true
        this.labelMapper = {
          'brand': 'Brand',
          'processor_type': 'Processor',
          // 'gpu_type': 'GPU'
        }
      }
      this.sov()
      this.website_details()
      this.ryzenVsNonRyzen()
      this.getDailyData()
      this.getComData()
      this.getProducts()
    },
  	sov(){
      let self = this
      self.activeChart = false
      self.loader = true
      const url = "/api/websites/sov"
      let payload = {}
      payload["website"] = []
      payload["timestamp"]  = self.date.startDate
      if (self.selected_website == 'all')
      {
        for(let [idx, dataset] of Object.entries(self.websitesUrls))
        {
          if(dataset !='hp') payload["website"].push(idx)
        }
      }
      else
      {
        payload["website"].push(self.selected_website)
      }
  		this.$http.post(url, payload).then(response => {
        let responseData = {
          "status": 200,
          "data": {
            "all": {},
            "sov": [{
              "page_1_count": 16,
              "page_1_3_count": 48,
              "page_1_sov": 0,
              "sub_brand": "plantronics",
              "brand": "plantronics",
              "page_all_sov": 0.0,
              "page_1_system_count": 0,
              "page_all_count": 0,
              "page_1_3_sov": 0,
              "form_factor": "NB",
              "page_all_system_count": 0,
              "page_1_3_system_count": 0
            }, {
              "page_1_count": 16,
              "page_1_3_count": 48,
              "page_1_sov": 100,
              "sub_brand": "Non-plantronics",
              "brand": "Non-plantronics",
              "page_all_sov": 0.0,
              "page_1_system_count": 16,
              "page_all_count": 0,
              "page_1_3_sov": 100,
              "form_factor": "NB",
              "page_all_system_count": 0,
              "page_1_3_system_count": 48
            }]
          },
          "success": true
        }
        this.rows = responseData.data.sov
        this.sos_rows = responseData.data.sov
        self.loader = false
        self.$nextTick(function(){
          let xaxis = []
          let data1 = []
          let data2 = []
          let data3 = []
          let data4 = []
          let max1 = 0
          let max2 = 0
          let limit = 9
          let textCat = 'Page 1 Count: <b>' + 16 + 
                    '</b><br/>Pages 1-3 Count: <b>'+ 48 +
                    '</b><br/>AMD Laptops Count: <b>' +  100 + '</b>'
          let textSch = 'Page 1 Count: <b>' + 16 + 
                        '</b><br/>Pages 1-3 Count: <b>'+48+
                        '</b><br/>AMD Laptops Count: <b>' +  500 + '</b>'
          if ((self.rows[0].page_all_system_count == 0 ) || (self.selected_website == 'all')) 
          {
            textCat = 'Page 1 Count: <b>' + 16  + 
                    '</b><br/>Pages 1-3 Count: <b>'+ 48 + '</b>'
            textSch = 'Page 1 Count: <b>' + 16 + 
                        '</b><br/>Pages 1-3 Count: <b>'+48+ '</b>' 
            limit = 9
          }
          for(let [idx, dataset] of self.columns.slice(3,limit).entries()) 
          {

            if((dataset.field!='page_1_count') && (dataset.field!='page_all_count') && (dataset.field!='page_1_system_count') && (dataset.field!='page_all_system_count') && (dataset.field!='page_1_3_count')&& (dataset.field!='page_1_3_system_count'))
            {
              var d1 = Number(self.rows[0][dataset.field].toFixed())
              var d2 = Number(self.rows[1][dataset.field].toFixed())
              var d3 = Number(self.sos_rows[0][dataset.field].toFixed())
              var d4 = Number(self.sos_rows[1][dataset.field].toFixed())
              if(d1>=max1) max1 = d1
              if(d2>=max1) max1 = d2
              if(d3>=max2) max2 = d3
              if(d4>=max2) max2 = d4
              xaxis.push(dataset.label)
              data1.push(d1)
              data2.push(d2)
              data3.push(d3)
              data4.push(d4)
            }
          }  
         

          self.charts = 
            {
              credits: {
                enabled: false
              },
              chart: {
                type:'column',
                height:320,
                inverted:true
              },
              title: {
                text: ''
              },
              subtitle: {
                  align:'left',
                  text: textCat
              },
              yAxis: {
                  title: {
                      text: ''
                  },
                  max:max1 + 5
              },
               plotOptions: {
                column: {
                    dataLabels: {
                        enabled: true,
                        color:'black',
                        inside: false,
                        formatter:function(){
                          let mapper = {}
                          let d = this.series.userOptions.allData
                          mapper['Page 1 SOV'] =  d.page_1_system_count+ '/' + d.page_1_count
                          mapper['Pages 1-3 SOV'] =  d.page_1_3_system_count+ '/' + d.page_1_3_count
                          mapper['All Pages SOV'] = d.page_all_system_count+ '/' + d.page_all_count
                          if(mapper[this.key])
                            return this.point.y + '%'
                          else
                            return this.point.y 
                        }
                    }
                }
    },
              xAxis:{
                categories: xaxis,
                crosshair: true,
              },
              tooltip: {
                formatter: function() {
                  var mytooltip = this.points[0].key + '<br/>';
                  for(var i = 0;i<this.points.length;i++)
                  {
                    mytooltip += '<span style="color:' + this.points[i].series.color + '">\u25CF</span> '
                    mytooltip += this.points[i].series.name
                    mytooltip += ' : <b> ' + self.format(this.points[i].y);
                    if(this.points[0].key.indexOf('SOV')!=-1)
                      mytooltip += '%'
                    mytooltip += '</b><br/>'
                  }
                  return mytooltip;
                },
                shared: true
              },
              series: [ 
              {
                name:self.rows[0]['sub_brand'],
                data:data1,
                color:'#3368fa8c',
                allData: self.rows[0] 
              }, 
              { 
                name:self.rows[1]['sub_brand'],
                data:data2,
                color:'#833c808c',
                allData: self.rows[1] 
              } ]
            }
          self.charts_sos = 
            {
              credits: {
                enabled: false
              },
              chart: {
                type:'column',
                height:320,
                inverted:true
              },
              title: {
                text: ''
              },
              subtitle: {
                  align:'left',
                  text: textSch
              },

              yAxis: {
                  title: {
                      text: ''
                  },
                  max: max2 + 5
              },
               plotOptions: {
                column: {
                    dataLabels: {
                        enabled: true,
                        color:'black',
                        formatter:function(){
                          let mapper = {}
                          let d = this.series.userOptions.allData
                          mapper['Page 1 SOV'] =  d.page_1_system_count+ '/' + d.page_1_count
                          mapper['Pages 1-3 SOV'] =  d.page_1_3_system_count+ '/' + d.page_1_3_count
                          mapper['All Pages SOV'] = d.page_all_system_count+ '/' + d.page_all_count
                          if(mapper[this.key])
                            return this.point.y + '%'
                          else
                            return this.point.y 
                        }
                    }
                }
              },
              xAxis:{
                categories: xaxis,
                crosshair: true,
              },
              tooltip: {
                formatter: function() {
                  var mytooltip = this.points[0].key + '<br/>';
                  for(var i = 0;i<this.points.length;i++)
                  {
                    mytooltip += '<span style="color:' + this.points[i].series.color + '">\u25CF</span> '
                    mytooltip += this.points[i].series.name
                    mytooltip += ' : <b> ' + self.format(this.points[i].y);
                    if(this.points[0].key.indexOf('SOV')!=-1)
                      mytooltip += '%'
                    mytooltip += '</b><br/>'
                  }
                  return mytooltip;
                },
                shared: true
              },
              series: [ 
              {
                name:self.sos_rows[0]['sub_brand'],
                data:data3,
                color:'#3368fa8c',
                allData: self.sos_rows[0] 
              }, 
              { 
                name:self.sos_rows[1]['sub_brand'],
                data:data4,
                color:'#833c808c',
                allData: self.sos_rows[1] 
              } ]
            }
          $('#myTable').DataTable();
          self.activeChart = true
        })
         
      }, err => {
        self.loader = false
      });
  	},
    format(v)
    {
      return this.$options.filters.format(v)
    }, 
    countIt(listingType,dataset){
      let self = this
      for(let [i, d] of Object.entries(this.labelMapper))
      {
        if(dataset[i]=="" || dataset[i]==" " ) dataset[i] = "N/A"
        if(dataset[i].indexOf('amd')!=-1) dataset[i] = dataset[i].replace('amd','AMD')
        if(dataset[i].indexOf('hp')!=-1) dataset[i] = dataset[i].replace('hp','HP')
        if (isNaN(self[listingType][i][dataset[i]]))
          self[listingType][i][dataset[i]] = 1
        else  
          self[listingType][i][dataset[i]]++
      } 
    },
    getColorShades(baseColor){
      if(this.index[baseColor] > this.colorShades[baseColor].length-1)
      {
        this.index[baseColor] = 0
      }
      let c = this.colorShades[baseColor][this.index[baseColor]]
      this.index[baseColor]++
      return c
    },
    generatePieCharts(listingType,chartKey){
      let self = this
      for(let [idx, dataset] of Object.entries(self[listingType])) 
      {
        let seriesData = []
        let finalSeriesData = []
        let color_codes = ['#78b2fb','#cefb78','#fb7878','#b0e1ff','#78eefb','#91ce8e','#59cdfb','#fbd378','#c139a4']
        let color_index = 0
        let color_index1 = 0
        let color_index3 = 0
        for(let [idx2, dataset2] of Object.entries(dataset))
        {
          let obj = {}
          let color = {}
          let whichCpu = ''
          let whichGpu = ''
          if (idx=='brand') 
          {
            color[idx2] = color_codes[color_index3]
            color_index3 = color_index3 + 1
          } 
          else if (idx=='processor_type') 
          {
            if ((idx2.indexOf('amd')!=-1)||(idx2.indexOf('AMD')!=-1))
            {
              color[idx2] = color_codes[color_index]
              whichCpu = 'amd' 
            }
            else if ((idx2.indexOf('intel')!=-1) || (idx2.indexOf('pentium')!=-1) || (idx2.indexOf('core')!=-1) )
              {
                whichCpu = 'intel' 
                color[idx2] = color_codes[color_index]
              }
            else
            {
              whichCpu = 'N/A' 
            }
            color_index = color_index + 1  
          }
          else if (idx=='gpu_type') 
          {
            if ((idx2.indexOf('amd')!=-1)||(idx2.indexOf('radeon')!=-1) ) 
            {
              whichGpu = 'amd'
              color[idx2] = color_codes[color_index1]
            }
            else if ((idx2.indexOf('intel')!=-1) || (idx2.indexOf('uhd')!=-1) || (idx2.indexOf('iris')!=-1) || (idx2.indexOf('integrated')!=-1) )
            {
              whichGpu = 'intel'
              color[idx2] = color_codes[color_index1]
            }
            else if ((idx2.indexOf('nvidia')!=-1) || (idx2.indexOf('geforce')!=-1) )
            {
              whichGpu = 'nvidia'
              color[idx2] = color_codes[color_index1]
            }  
            else 
            {
              whichGpu = 'N/A'
            }
            color_index1 = color_index1 + 1
          }
          if (idx2 =='N/A')
            color[idx2] = '#b9c6de'
         
          obj['name'] = idx2 
          obj['y'] = dataset2
          obj['cpu'] = whichCpu
          obj['gpu'] = whichGpu
          if(color[idx2])
            obj['color'] = color[idx2]
          seriesData.push(obj)    
        } 
        if (idx=='brand') 
        {
          finalSeriesData = seriesData
        }
        else if (idx=='processor_type') 
        {
          for(let [idx, dataset] of seriesData.entries()) 
          {
             if(dataset.cpu=='N/A') finalSeriesData.push(dataset)
          } 
          for(let [idx, dataset] of seriesData.entries()) 
          {
             if(dataset.cpu=='amd') finalSeriesData.push(dataset)
          }  
          for(let [idx, dataset] of seriesData.entries()) 
          {
             if(dataset.cpu=='intel') finalSeriesData.push(dataset)
          } 
          
        }
        else if (idx=='gpu_type') 
        {
          for(let [idx, dataset] of seriesData.entries()) 
          {
             if(dataset.gpu=='N/A') finalSeriesData.push(dataset)
          } 
          for(let [idx, dataset] of seriesData.entries()) 
          {
             if(dataset.gpu=='amd') finalSeriesData.push(dataset)
          }  
          for(let [idx, dataset] of seriesData.entries()) 
          {
             if(dataset.gpu=='intel') finalSeriesData.push(dataset)
          } 
          for(let [idx, dataset] of seriesData.entries()) 
          {
             if(dataset.gpu=='nvidia') finalSeriesData.push(dataset)
          } 
         
        }
        self[chartKey][idx] = {
          chart: {
            margin: [80,0,35,0],
            padding:[0,0,0,0]
           
          },
          title: {  
              text:  'Laptop Category Page ('+ self.selectedPage +') Distribution by ' + self.labelMapper[idx],
              verticalAlign:'bottom',
              style:{fontSize:13}
          },
          credits: {
            enabled: false
          },
          accessibility: {
            point: {
                valueSuffix: '%'
            }
          },
          tooltip: {
            formatter(){
              var mytooltip = ''
              mytooltip += '<span style="font-size:22px;color:' + this.point.color + '">\u25CF</span> '
              mytooltip += this.point.name
              mytooltip += ' : <b> ' + self.format(this.point.y) + ' (' + self.format(this.point.percentage.toFixed())  + '%)</b> <br/>'
              mytooltip += 'Total: <b>' + self.format(this.point.total) + '</b>'
              return mytooltip;             
            },
          },
          plotOptions: {
              series: {
                  borderWidth: 0,
              },
              pie: {
                  dataLabels: {
                    enabled: true,
                    useHTML: true,
                    formatter: function() { 
                      self.pieTotal = this.point.total 
                     
                      return  '<span style="color:black;font-size:11px;font-weight:normal;">' +self.format(this.point.percentage.toFixed()) + '%</span>'
                    },
                    distance: -13,
                    style: {
                      fontSize: 11,
                    }  
                  },
                  showInLegend: true,
                  size: '100%'
              }
          },
          legend:{
            align: 'center',
            layout: 'horizontal',
            verticalAlign: 'top',
            itemStyle: {
              fontSize: 11,
              fontWeight: 1
            },
            maxHeight: 65, 
          },  
          series: [{  
            type: 'pie',
            data: finalSeriesData
          }]
        } 
        setTimeout(function(){
          self.activePie = true
        },50)
      }
    },
    readyPieCharts(){
      let self = this
      self.clearPieDataset()
      for(let [idx, dataset] of this.rows_details.entries()) 
      {
        if ((self.selectedPage == 1) && (dataset.page!=1)) continue
        if (dataset.processor == 'amd')
        {
          if(self.amdCPUFilter == 'all')
          {
            self.countIt('countAMD',dataset)
          }
          else if (self.amdCPUFilter == 'ryzen')
          {
            if(dataset.processor_type.indexOf('ryzen')!=-1)
              self.countIt('countAMD',dataset)
            else
              continue
         }
         else
         {
           if(dataset.processor_type.indexOf('ryzen')==-1)
              self.countIt('countAMD',dataset)
            else
              continue
         }
        }
      }
      self.generatePieCharts('countAMD','pieChartAMD') 
    },
    createPie(){
      let self = this
      let color_codes = ['#78b2fb','#cefb78','#fb7878','#b0e1ff','#78eefb','#91ce8e','#59cdfb','#fbd378','#c139a4']
      let color_index = 0
      let color = {}
      let total = 0
      let seriesData = []
      for(const property in self.labelMapper)
      {
        if(property=='brand')
          seriesData = self.pie_brand
        else if(property=='processor_type')
          seriesData = self.pie_cpu
        for(let [idx, dataset] of seriesData.entries())
        {
          color[dataset.name] = color_codes[color_index]
          color_index = color_index + 1
          dataset.color = color[dataset.name]
          total = total + dataset.y
        }
        for(let [idx, dataset] of seriesData.entries())
        {
          dataset.total = total
        }
        seriesData = [
          {"name":"plantronics","y":0,"color":"#78b2fb","total":48},
          {"name":"ptron","y":7,"color":"#cefb78","total":48},
          {"name":"boat","y":3 ,"color":"#fb7878","total":48},
          {"name":"zebronics","y":1,"color":"#ed77f4","total":48},
          {"name":"other","y":37,"color":"#b0e1ff","total":48}]
        self['pieChartAMD'][property] = {
            chart: {
              margin: [80,0,35,0],
              padding:[0,0,0,0]
             
            },
            title: {  
                text:  'Bluetooth headphone search Page ('+ self.selectedPage +') Distribution by ' + self.labelMapper[property],
                verticalAlign:'bottom',
                style:{fontSize:13}
            },
            credits: {
              enabled: false
            },
            accessibility: {
              point: {
                  valueSuffix: '%'
              }
            },
            tooltip: {
              formatter(){
                var mytooltip = ''
                mytooltip += '<span style="font-size:22px;color:' + this.point.color + '">\u25CF</span> '
                mytooltip += this.point.name
                mytooltip += ' : <b> ' + self.format(this.point.y) + ' (' + self.format(this.point.percentage.toFixed())  + '%)</b> <br/>'
                mytooltip += 'Total: <b>' + self.format(this.point.total) + '</b>'
                return mytooltip;             
              },
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                },
                pie: {
                    dataLabels: {
                      enabled: true,
                      useHTML: true,
                      formatter: function() { 
                        self.pieTotal = this.point.total 
                       
                        return  '<span style="color:black;font-size:11px;font-weight:normal;">' +self.format(this.point.percentage.toFixed()) + '%</span>'
                      },
                      distance: -13,
                      style: {
                        fontSize: 11,
                      }  
                    },
                    showInLegend: true,
                    size: '100%'
                }
            },
            legend:{
              align: 'center',
              layout: 'horizontal',
              verticalAlign: 'top',
              itemStyle: {
                fontSize: 11,
                fontWeight: 1
              },
              maxHeight: 65, 
            },  
            series: [{  
              type: 'pie',
              data: seriesData
            }]
          }
          setTimeout(function(){
            self.activePie = true
          },50)
        }
    },
    readyPie(){
      let self = this
      let filter_data = []
      self.pie_brand = []
      self.pie_cpu = []
      this.brand_list = self.pie_data[self.amdCPUFilter][self.selectedPage]['brand_list']
      this.cpu_list = self.pie_data[self.amdCPUFilter][self.selectedPage]['cpu_list']
      for(let [idx, dataset] of this.brand_list.entries())
      {
        let di = {}
        di['name'] = dataset['key']
        di['y'] = dataset['doc_count']
        if(di['name']=="")
          di['name'] = "N/A"
        if(di['name'].indexOf('amd')!=-1) di['name'] = di['name'].replace('amd','AMD')
        if(di['name'].indexOf('hp')!=-1) di['name'] = di['name'].replace('hp','HP')
        self.pie_brand.push(di)
      }
      for(let [idx, dataset] of this.cpu_list.entries())
      {
        let di = {}
        di['name'] = dataset['key']
        di['y'] = dataset['doc_count']
        if(di['name']=="")
          di['name'] = "N/A"
        if(di['name'].indexOf('amd')!=-1) di['name'] = di['name'].replace('amd','AMD')
        if(di['name'].indexOf('hp')!=-1) di['name'] = di['name'].replace('hp','HP')
        self.pie_cpu.push(di)
      }
      self.createPie()
    },
    clearPieDataset(){
      let self = this
      for(let [i, d] of Object.entries(this.labelMapper))
      {
        self.countAMD[i] = {}
        self.pieChartAMD[i] = {}
      }
    },
 
    website_details(){
      let self = this
      // self.loader = true
      self.rows_details = []
      self.activePie = false
      // const url = "/api/websites/details"
      const url = "/api/websites/website_metrics"
      let page = null
      if(self.selectedPage == 1)
        page=1
      let payload = {}
      payload["website"] = []
      payload["timestamp"]  = self.date.startDate
      payload["page"] = page
      payload["processor"] = this.amdCPUFilter
      if (self.selected_website == 'all')
      {
        for(let [idx, dataset] of Object.entries(self.websitesUrls))
        {
          if(dataset !='hp') payload["website"].push(idx)
        }
      }
      else
      {
        payload["website"].push(self.selected_website)
      }  
      this.$http.post(url, payload).then(response => {
        // this.brand_list = response.body.data.brand_list
        // this.cpu_list = response.body.data.cpu_list
        this.pie_data = response.body.data
        // self.loader = false
        self.readyPie()
        // self.readyPieCharts()
      }, err => {
        self.loader = false
      });
    },

    changeCustomDate(){
      if (this.date.startDate)
        this.date.startDate = moment(this.date.startDate).format('YYYY-MM-DD')
    },
  
  }
}

</script>

<style scoped>
.eachProduct:hover
{
    background: #d4d4d4;
}
.custom-table
{
  padding: 10px;
  margin:10px;
}

.markitamd
{
  background-color:#ffb9b9!important
}
.markitintel
{
  background-color:#c7e0ff!important;
}
.markitsnap
{
  background-color:#ffd0f5 !important
}
.markitna
{
  background-color:#edf2fb!important
}
.markittek
{
  background-color:#fff0ce!important
}
.space-between-header
{
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 10px;
 
  padding-bottom: 5px;
}
.space-between-header select
{
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}
.space-between-header h3 {
  color:#4e4e4e;
    margin-bottom: 0;
    line-height: 31px;
}
.listing-custom
{
    font-size: 18px;
    margin-bottom: 6px;
    text-align: center;
    width: 215px;
    background: #8a87e8;
}
.hint
{
  cursor: pointer;
  background: #f5f5f5;
  color: #080808;
  padding: 3px;
  font-size: 9px;
} 
.amd-legend
{
  text-align: center;
  position: absolute;
  left: 15%;
  right: 15%;
  z-index:999
}
.amd-legend i
{
  
  width: fit-content;
}
.amd-legend span
{
    padding-left: 4px;
    font-size: 12px;
}
.legending
{
  display: inline-block;
  margin-right: 19px;
}
#avgTable th, #avgTable td
{
  border:1px solid #c8ced3!important;
  text-align:left;
  font-size:14px
}
.mycol
{
  padding-right:15px!important;
  padding-left:15px!important;
}
.mycols:first-child
{
 padding-right:2px!important
}
.mycols:last-child
{
 padding-left:2px
}
.mycols:not(:first-child):not(:last-child)
{
 padding-left:2px;
 padding-right:2px
}
.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle
{
      color: #ffffff;
    background-color: #8a87e8;
    border-color: #8a87e8;
    height:30px;
    border-radius:0
}
.btn-outline-secondary
{
  height:30px;
   border-radius:0;
   line-height: 17px;
   background:white
}
.sovdetails{
      float: right;
    height: 30px;
    margin: 0;
    border-radius: 0;
    font-size: 15px;
    padding: 7px;
    width: max-content;
    cursor: pointer;
    margin-left: 4px;
}
</style>
